// CNPJ
// Validate, generate and format CNPJ numbers
// https://github.com/fnando/cnpj
import * as cnpj from '@fnando/cnpj'

const validator = {
  /**
   * Valida se um valor é do tipo CNPJ
   * @param  {String} value [description]
   * @param  {Object} args  [description]
   * @return {Boolean}      Retorna se o campo é valido
   */
  validate (value, args) {
    return cnpj.isValid(value, true)
  }
}

export default validator
